import { SFuncModal } from 'shj-components';
import { Form, message } from 'antd';
import { useRequest } from "ahooks";
import TextArea from 'antd/es/input/TextArea';
import {savePraise} from '@/services/evaluateConfig';
import {useEffect} from "react";

export function addLikeFn({ fn, ...rest }) {
    const onClose = () => {
        dialog.destroy();
    };
    const dialog = SFuncModal({
        title: '服务赞点',
        width: 500,
        vanish: true,
        content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}

const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
    const [form] = Form.useForm();
    const { loading: saveLoading, runAsync: runAsyncSave } = useRequest(savePraise, { manual: true });

    useEffect(() => {
        form?.setFieldsValue({
            praise: rest?.praise||""
        })
    }, [rest?.praise]);
    // 提交
    const onFinish = () => {
        form.validateFields().then((values: any) => {
          runAsyncSave({ ...values, id: rest.id }).then((res: any) => {
                if (res) {
                    message.success('提交成功');
                    onClose();
                    fn && fn();
                } else {
                    message.error(res)
                    return
                }
            })
        })

    };

    const closeModal = () => {
        onClose();
    };
    return (
        <div>
            <SFuncModal.Content
                onCancel={closeModal}
                onOk={onFinish}
                confirmLoading={saveLoading}>
                <Form
                    layout="vertical"
                    form={form}>
                    <Form.Item
                        label="赞点"
                        name="praise"
                        rules={[{ required: true, message: '请输入' }]}
                    >
                        <TextArea placeholder="请输入" rows={2} maxLength={200} showCount />
                    </Form.Item>
                </Form>
            </SFuncModal.Content>
        </div>
    );
};
